import { localeOf } from './locale';

// Como se ve cada notificacion: la usan la pagina de notificaciones y el
// desplegable del lateral, para que las dos digan lo mismo.

const PLAN_KEYS = ['free', 'basic', 'pro', 'business'];

const planName = (level, t) => t(`profile_plan_${PLAN_KEYS[Math.min(Math.max(Number(level) || 0, 0), 3)]}`);

export const notificationView = (notification, t, language) => {
  const locale = localeOf(language);

  if (notification.type === 'plan_expiring') {
    const date = notification.expires_at
      ? new Date(notification.expires_at).toLocaleDateString(locale, { day: 'numeric', month: 'long' })
      : '';
    return {
      kind: 'plan',
      title: t('notif_plan_expiring').replace('{plan}', planName(notification.plan, t)).replace('{date}', date),
      href: '/subscribe',
      action: t('notif_view_plans')
    };
  }

  if (notification.type === 'plan_expired') {
    return {
      kind: 'plan',
      title: t('notif_plan_expired').replace('{plan}', planName(notification.plan, t)),
      href: '/subscribe',
      action: t('notif_view_plans')
    };
  }

  if (notification.type === 'ong_pending') {
    return {
      kind: 'plan',
      title: t('notif_ong_pending').replace('{org}', notification.organizacion || ''),
      href: '/profile',
      action: t('notif_ong_view')
    };
  }

  if (notification.type === 'ong_approved' || notification.type === 'ong_rejected') {
    const rejected = notification.type === 'ong_rejected';
    const base = t(rejected ? 'notif_ong_rejected' : 'notif_ong_approved').replace('{org}', notification.organizacion || '');
    return {
      kind: rejected ? 'plan' : 'done',
      title: rejected && notification.motivo ? `${base} ${notification.motivo}` : base,
      href: '/profile',
      action: t('notif_ong_view')
    };
  }

  // El servidor manda el título y cuánta gente ha respondido; el texto se escribe aquí, en el idioma de la web
  if (notification.type === 'inferred_completed') {
    const personas = Number(notification.personas) || 0;
    return {
      kind: 'done',
      title: t(personas === 1 ? 'notif_survey_completed_one' : 'notif_survey_completed')
        .replace('{title}', notification.titulo || '')
        .replace('{n}', personas),
      href: notification.id_encuesta ? `/dashboard/${notification.id_encuesta}` : null,
      action: t('notif_view_results')
    };
  }

  if (notification.type === 'launched') {
    return {
      kind: 'survey',
      title: `${t('notif_survey_launched')} ${notification.titulo}`,
      href: notification.id_encuesta ? `/dashboard?encuesta=${notification.id_encuesta}` : null,
      action: t('notif_view_survey')
    };
  }

  return {
    kind: 'done',
    title: notification.titulo,
    href: notification.id_encuesta ? `/dashboard?encuesta=${notification.id_encuesta}` : null,
    action: t('notif_view_survey')
  };
};

export default notificationView;
